/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../../../styles/colors';
import { typography } from '../../../../../../styles/typography';
import { MediaQueries } from '../../../../../../styles/Grid';

export const solutionItem = css({
  marginBottom: 24,

  '&:last-child': {
    marginBottom: 0,
  },

  [MediaQueries.lgAndUp]: {
    marginBottom: 0,
    borderBottom: `1px solid ${colorsPalette.grey10}`,

    '&:last-child': {
      borderBottom: 0,
    },
  },
});

export const defaultSolutionOption = css(typography.effra18, {
  background: 'transparent',
  border: 'none',
  color: colorsPalette.black,
  cursor: 'pointer',
  letterSpacing: 0,
  outline: 'none',
  paddingLeft: 27,
  position: 'relative',
  textAlign: 'left',
  verticalAlign: 'top',
  [MediaQueries.lgAndUp]: {
    color: colorsPalette.grey80,
    display: 'inline-block',
    height: 56,
    padding: '12px 32px',
    width: '100%',

    '&:hover, &:focus': {
      backgroundColor: colorsPalette.teal,
      color: colorsPalette.white,
    },
  },
});

export const currentSolutionOption = css({ color: colorsPalette.teal });

export const checkmark = css({
  alignItems: 'center',
  display: 'inline-flex',
  fontSize: 10,
  height: 32,
  left: 0,
  position: 'absolute',
  verticalAlign: 'top',
});
